<template>
  <div>
    <Loading :isLoading="this.isLoading"/>
    <div style="margin-top:30px;">
      <Access ref="accessComponent" v-on:search-info-by-rfc-nip="getResponseAccess($event)" />
    </div>
    <div style="margin-top:30px;" v-if="rfcIsValid">
      <form @submit="save">
        <div>
          <PersonalInfo title="Datos personales" :name="`${paternalName} ${maternalName} ${name}`" :rfc="rfcToShow" />
        </div>
        <div style="margin-top:20px;">
          <p class="personalInfoTitle">Ingresar los datos siguientes:</p>
        </div>
        <div style="margin-top:10px;">
          <div class="mb-4" style="margin-top:10px;">
            <input class="inputsForm" id="input_no_debt_certificate_email" type="text" v-model.trim="$v.email.$model" 
              :class="{'inputs-invalid-form':$v.email.$error, 'inputsForm':!$v.email.$invalid}" placeholder="Correo Electrónico" />
            <div class="content-text">
              <div v-if="$v.email.$error" class="text">
                <span class="errors" v-if="!$v.email.required">El correo electrónico es requerido</span>
                <span class="errors" v-if="!$v.email.isUnique">El formato del correo electrónico no es correcto. (su-correo@ejemplo.com)</span>
              </div>
            </div>
          </div>
          <div class="mb-4" style="">
            <input class="inputsForm upperCaseTransform" id="input_no_debt_certificate_budget_key_1" type="text" placeholder="Clave Presupuestal 1" 
              :class="{'inputs-invalid-form':$v.budgetKey1.$error, 'inputsForm':!$v.budgetKey1.$invalid}" v-model.trim="$v.budgetKey1.$model" />
            <div class="content-text">
              <div v-if="$v.budgetKey1.$error" class="text">
                <span class="errors" v-if="!$v.budgetKey1.required">La clave presupuestal 1 es requerido</span>
                <span class="errors" v-if="!$v.budgetKey1.minLength">Debe ingresar más de 4 caracteres en la clave presupuestal 1</span>
                <span class="errors" v-if="!$v.budgetKey1.maxLength">Debe ingresar máximo 20 caracteres en la clave presupuestal 1</span>
                <span class="errors" v-if="!$v.budgetKey1.isUnique">La clave presupuestal '{{budgetKey1}}' ya ha sido ingresada</span>
              </div>
            </div>
          </div>
          <div class="mb-4" style="">
            <input class="inputsForm upperCaseTransform" id="input_no_debt_certificate_budget_key_2" type="text" 
              :class="{'inputs-invalid-form':$v.budgetKey2.$error, 'inputsForm':!$v.budgetKey2.$invalid}"
              placeholder="Clave Presupuestal 2" :disabled="budgetKey1 == '' || budgetKey1.length < 4" v-model="$v.budgetKey2.$model" />
            <div class="content-text">
              <div v-if="$v.budgetKey2.$error" class="text">
                <span class="errors" v-if="!$v.budgetKey2.minLength">Debe ingresar más de 4 caracteres en la clave presupuestal 2</span>
                <span class="errors" v-if="!$v.budgetKey2.maxLength">Debe ingresar máximo 20 caracteres en la clave presupuestal 2</span>
                <span class="errors" v-if="!$v.budgetKey2.isUnique">La clave presupuestal '{{budgetKey2}}' ya ha sido ingresada</span>
              </div>
            </div>
          </div>
          <div class="mb-4" style="">
            <input class="inputsForm upperCaseTransform" id="input_no_debt_certificate_budget_key_3" type="text"
              :class="{'inputs-invalid-form':$v.budgetKey3.$error, 'inputsForm':!$v.budgetKey3.$invalid}" 
              placeholder="Clave Presupuestal 3" :disabled="budgetKey2 == '' || budgetKey2.length < 4" v-model.trim="$v.budgetKey3.$model" />
            <div class="content-text">
              <div v-if="$v.budgetKey3.$error" class="text">
                <span class="errors" v-if="!$v.budgetKey3.minLength">Debe ingresar más de 4 caracteres en la clave presupuestal 3</span>
                <span class="errors" v-if="!$v.budgetKey3.maxLength">Debe ingresar máximo 20 caracteres en la clave presupuestal 3</span>
                <span class="errors" v-if="!$v.budgetKey3.isUnique">La clave presupuestal '{{budgetKey3}}' ya ha sido ingresada</span>
              </div>
            </div>
          </div>
          <div>
            <button class="AccessButton" id="button_request">Solicitar</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2'
import Loading from '@/components/Loading/Loading.vue'
import User from '@/classes/User'
import NoDebtLetter from '@/classes/NoDebtCertificate'
import Access from '@/components/Forms/Access.vue'
import PersonalInfo from '@/components/PersonalInfo/PersonalInfo.vue'

import {validateEmail} from '@/helpers/email'
import {required, minLength, maxLength, email} from 'vuelidate/lib/validators'
import('@/assets/css/stylesheet.css')

export default {
  data() {
    return {
      isLoading: false,
      rfcToShow: "",
      name: "",
      maternalName: "",
      paternalName: "",
      email: "",
      budgetKey1: "",
      budgetKey2: "",
      budgetKey3: "",
      userObjectClass: null,
      noDebtLetterObjectClass: null,
      rfcIsValid: false,
      token_auth: "",
      userFas: process.env.VUE_APP_USER_FAS,
      passwordFas: process.env.VUE_APP_PASSWORD_FAS,
    }
  },
  validations: {
    email: {
      required,
      email,
      isUnique(value) {
        return validateEmail(value);
      }
    },
    budgetKey1: {
      required,
      minLength: minLength(4),
      maxLength: maxLength(20),
      isUnique(value) {
        if (value != "") {
          if (value == this.budgetKey2 || value == this.budgetKey3) {
            return false;
          }          
        }
        
        return true;
      }
    },
    budgetKey2: {
      minLength: minLength(4),
      maxLength: maxLength(20),
      isUnique(value) {
        if (value != "") {
          if (value == this.budgetKey1 || value == this.budgetKey3) {
            return false;
          }  
        }

        return true;
      }
    },
    budgetKey3: {
      minLength: minLength(4),
      maxLength: maxLength(20),
      isUnique(value) {
        if (value != "") {
          if (value == this.budgetKey1 || value == this.budgetKey2) {
            return false;
          }
        }
        
        return true;
      }
    }
  },
  name: 'NoDebtLetterComponent',
  components: {
    Loading,
    Access,
    PersonalInfo
  },
  mounted(){
    this.userObjectClass = new User();
    this.noDebtLetterObjectClass = new NoDebtLetter();
    this.login();
  },
  methods: {
    getResponseAccess(event) {
      if (event.rfcIsValid) {
        this.setAuthenticatedUserInformation(event.data) 
      }
      this.rfcIsValid = event.rfcIsValid;
    },
    save(e) {
      e.preventDefault();

      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.isLoading = true;
        let budgetKeys = this.getArrayBudgetKeys(this.budgetKey1, this.budgetKey2, this.budgetKey3);

        this.noDebtLetterObjectClass.register({
          token_auth: this.token_auth,
          rfc: this.rfcToShow,
          name: this.name,
          middle_name: "",
          maternal_name: this.maternalName,
          paternal_name: this.paternalName,
          email: this.email,
          budget_keys: budgetKeys
        }).then(response => {
          this.isLoading = false;
          this.cleanFields();
          this.$refs.accessComponent.cleanFields();
          Swal.fire({
            text: "Solicitud de Carta de no Adeudo guardada correctamente",
            html: `<p style="font-size:18px;font-weight:bold;">Solicitud de Carta de no Adeudo guardada correctamente</p><br/>
                  <p style="font-size:14px;">Todas las solicitudes capturadas a través de esta página, 
                  serán analizadas y sujetas a aprobación por parte del Comité Técnico de la Sección 17.</p>`,
            confirmButtonText: "Continuar",
            allowOutsideClick: false,
            icon: "success",
          }).then((response)=>{
            //this.$router.push({ name: 'HomeLoanRequest' });
          });
        }).catch(error => {
          this.isLoading = false;
            Swal.fire({
            title: "Aviso",
            text: error,
            icon: "error",
          });
        })
      }
    },
    setAuthenticatedUserInformation(userAuthenticated) {
      this.name = userAuthenticated.name;
      this.paternalName = userAuthenticated.paternal_name;
      this.maternalName = userAuthenticated.maternal_name;
      this.rfcToShow = userAuthenticated.rfc;
    },
    getArrayBudgetKeys(budgetKey1, budgetKey2, budgetKey3){
      let budgetKeys = [];

      if(budgetKey1 != "" && budgetKey1 != null && budgetKey1 != undefined)
        budgetKeys.push(budgetKey1);
      if(budgetKey2 != "" && budgetKey2 != null && budgetKey2 != undefined)
        budgetKeys.push(budgetKey2);
      if(budgetKey3 != "" && budgetKey3 != null && budgetKey3 != undefined)
        budgetKeys.push(budgetKey3);

      return budgetKeys;
    },
    validateEmail(email) {
      var regex = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;
      if (regex.test(email)) {
        return true;
      }
      return false;
    },
    login() {
      this.isLoading = true;
      this.userObjectClass.login(this.userFas, this.passwordFas).then(response => {
        this.isLoading = false;
        this.token_auth = response.data.token_auth;
        console.log("token: ", this.token_auth);
      }).catch(error => {
        this.isLoading = false;
        Swal.fire({
          title: "Aviso",
          text: error,
          icon: "error",
        });
      });
    },
    cleanFields() {
      this.rfcToShow = "";
      this.rfcIsValid = false;
      this.name = "";
      this.paternalName = "";
      this.maternalName = "";
      this.email = "";
      this.budgetKey1 = "";
      this.budgetKey2 = "";
      this.budgetKey3 = "";
      this.$v.$reset()
    },
  }
}
</script>